import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged, ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import {
  AttributeDateFromChanged,
  AttributeDateUntilChanged,
  AttributeNameChanged,
  AttributeTypeChanged,
  AttributeValueChanged,
  BoolAttributeValueChanged,
  CardNumberChanged,
  ClearAttributeDateFrom,
  ClearAttributeDateUntil,
  ClearCustomerFilters,
  ClubChanged,
  CountryChanged,
  EmailChanged,
  FirstNameChanged,
  GetAttributeCodesSuccess,
  GetCategoriesSuccess,
  GetClubsSuccess,
  GetCountriesSuccess,
  GetLoyaltyMembersSuccess,
  GetSchemasSuccess,
  GetStoresSuccess,
  IncludeInactiveChanged,
  LastNameChanged,
  MainPanelStatusChanged,
  MemberCategoryChanged,
  MemberTagChanged,
  MobileChanged,
  QivosIDChanged,
  RegistrationDateFromChanged,
  RegistrationDateFromCleared,
  RegistrationDateUntilChanged,
  RegistrationDateUntilCleared,
  RegistrationStoreChanged,
  SchemaNameChanged,
} from '../actions/members-search.actions';
import { MembersSearchState } from '../models/members-search.models';

const initialState: MembersSearchState = {
  mainPanelExpanded: true,
  loyaltyPanelExpanded: true,
  personalPanelExpanded: false,
  otherPanelExpanded: false,
  cardNumber: '',
  schemaNameOptions: [],
  schema: 0,
  registrationDateFrom: '',
  registrationDateUntil: '',
  registrationStoreOptions: [],
  registrationStore: 0,
  memberCategoryOptions: [],
  memberCategory: 0,
  firstName: '',
  email: '',
  lastName: '',
  mobile: '',
  countryOptions: [],
  country: 0,
  memberTagOptions: [],
  memberTag: 0,
  clubOptions: [],
  club: 0,
  qivosID: '',
  attributes: [],
  attributeTypeOptions: ['INTEGER', 'STRING', 'BOOLEAN', 'DATE'],
  attributeType: '',
  attributeNameOptions: [],
  attributeName: '',
  attributeValue: '',
  attributeBoolValue: false,
  attributeDateFrom: '',
  attributeDateUntil: '',
  includeInactive: false,
};

export const MembersSearchReducer = createReducer(
  initialState,
  on(GetCountriesSuccess, (state, { res }) => ({
    ...state,
    countryOptions: res,
  })),
  on(GetSchemasSuccess, (state, { res }) => ({
    ...state,
    schemaNameOptions: res,
  })),
  on(GetStoresSuccess, (state, { res }) => ({
    ...state,
    registrationStoreOptions: res,
  })),
  on(GetCategoriesSuccess, (state, { res }) => ({
    ...state,
    memberCategoryOptions: res,
  })),
  //   on(GetPointSourcesSuccess, (state, { res }) => ({
  //   ...state,
  //   countryOptions: res,
  // })),
  on(GetLoyaltyMembersSuccess, (state, { res }) => ({
    ...state,
    memberTagOptions: res,
  })),
  //   on(GetCouponsetSuccess, (state, { res }) => ({
  //   ...state,
  //   couponset: res,
  // })),
  on(GetClubsSuccess, (state, { res }) => ({
    ...state,
    clubOptions: res,
  })),
  //   on(GetStatusesSuccess, (state, { res }) => ({
  //   ...state,
  //   sta: res,
  // })),
  on(GetAttributeCodesSuccess, (state, { res }) => ({
    ...state,
    attributes: res.payload.data,
  })),

  on(MainPanelStatusChanged, (state) => ({
    ...state,
    mainPanelExpanded: !state.mainPanelExpanded,
  })),
  on(CardNumberChanged, (state, { cardNumber }) => ({
    ...state,
    cardNumber,
  })),
  on(SchemaNameChanged, (state, { schemaName }) => ({
    ...state,
    schema: schemaName,
  })),
  on(RegistrationDateFromChanged, (state, { registrationDateFrom }) => ({
    ...state,
    registrationDateFrom,
  })),
  on(RegistrationDateUntilChanged, (state, { registrationDateUntil }) => ({
    ...state,
    registrationDateUntil,
  })),
  on(RegistrationDateFromCleared, (state) => ({
    ...state,
    registrationDateFrom: '',
  })),
  on(RegistrationDateUntilCleared, (state) => ({
    ...state,
    registrationDateUntil: '',
  })),
  on(RegistrationStoreChanged, (state, { registrationStore }) => ({
    ...state,
    registrationStore,
  })),
  on(MemberCategoryChanged, (state, { memberCategory }) => ({
    ...state,
    memberCategory,
  })),
  on(LastNameChanged, (state, { lastName }) => ({
    ...state,
    lastName,
  })),
  on(FirstNameChanged, (state, { firstName }) => ({
    ...state,
    firstName,
  })),
  on(EmailChanged, (state, { email }) => ({
    ...state,
    email,
  })),
  on(MobileChanged, (state, { mobile }) => ({
    ...state,
    mobile,
  })),
  on(CountryChanged, (state, { country }) => ({
    ...state,
    country,
  })),
  on(MemberTagChanged, (state, { memberTag }) => ({
    ...state,
    memberTag,
  })),
  on(ClubChanged, (state, { club }) => ({
    ...state,
    club,
  })),
  on(QivosIDChanged, (state, { qivosID }) => ({
    ...state,
    qivosID,
  })),
  on(AttributeTypeChanged, (state, { attributeType }) => ({
    ...state,
    attributeType,
    attributeNameOptions:
      state.attributes?.attributeCodes?.find(
        (attribute: any) => attribute.attributeType === attributeType,
      )?.attributeNames ?? [],
    attributeName: '',
    attributeBoolValue: false,
    attributeValue: '',
    attributeDateFrom: '',
    attributeDateUntil: '',
  })),
  on(AttributeNameChanged, (state, { attributeName }) => ({
    ...state,
    attributeName,
    attributeBoolValue: false,
    attributeValue: '',
    attributeDateFrom: '',
    attributeDateUntil: '',
  })),
  on(AttributeValueChanged, (state, { attributeValue }) => ({
    ...state,
    attributeValue,
  })),
  on(BoolAttributeValueChanged, (state) => ({
    ...state,
    attributeBoolValue: !state.attributeBoolValue,
  })),
  on(AttributeDateFromChanged, (state, { attributeDateFrom }) => ({
    ...state,
    attributeDateFrom,
  })),
  on(AttributeDateUntilChanged, (state, { attributeDateUntil }) => ({
    ...state,
    attributeDateUntil,
  })),
  on(ClearAttributeDateFrom, (state) => ({
    ...state,
    attributeDateFrom: '',
  })),
  on(ClearAttributeDateUntil, (state) => ({
    ...state,
    attributeDateUntil: '',
  })),
  on(IncludeInactiveChanged, (state) => ({
    ...state,
    includeInactive: !state.includeInactive,
  })),
  on(ActiveComponentChanged, (state, { activeComponent }) =>
    activeComponent === 'AllCustomersComponent' || activeComponent === 'MemberSearchComponent'
      ? {
          ...state,
        }
      : { ...initialState },
  ),
  on(ClearCustomerFilters, (state) => ({
    ...state,
    mainPanelExpanded: true,
    cardNumber: '',
    schema: 0,
    registrationDateFrom: '',
    registrationDateUntil: '',
    registrationStore: 0,
    memberCategory: 0,
    firstName: '',
    email: '',
    lastName: '',
    mobile: '',
    country: 0,
    memberTag: 0,
    club: 0,
    qivosID: '',
    attributeType: '',
    attributeName: '',
    attributeValue: '',
    attributeDateFrom: '',
    attributeDateUntil: '',
    includeInactive: false,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
